export default function() {
	const type = arguments[0];
	const args = Array.prototype.slice.call(arguments, 1);

	return function () {
		const values = Array.prototype.slice.call(arguments);
		const action = {
			type: type
		};

		if (values.length !== args.length) {
			return null;
		}

		for (let i = 0; i < args.length; i++) {
			action[args[i]] = values[i];
		}
		return action;
	};
}